import { render } from "./Logo.svg?vue&type=template&id=6599068a"
const script = {}
script.render = render

export default script